import BaseToast from './BaseToast';
import { observer } from 'mobx-react';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import { ControlIcons } from 'owa-control-icons';
import * as React from 'react';

let styles = require('./NotificationToast.scss');
let classNames = require('classnames');

@observer
export default class WarningToast extends BaseToast {
    render() {
        let { title, description, actionLink, cancelLink } = this.props.notification;

        return (
            <div className={styles.toast} onClick={this.onActionClick}>
                <div className={styles.iconContainer}>
                    <span className={classNames(styles.warningIconCircle, styles.imageCircle)}>
                        <Icon className={styles.warningIcon} iconName={ControlIcons.Warning} />
                    </span>
                </div>
                <div className={styles.toastInfo}>
                    <div className={styles.warningTitle}>{title}</div>
                    <div className={styles.description}>{description}</div>
                    <div className={styles.linksContainer}>
                        <div>{actionLink}</div>
                        {cancelLink && (
                            <div className={styles.closeLink} onClick={this.onCancelClick}>
                                {cancelLink}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        );
    }
}
